export const TYPE_CUBAGE_MAIN_TEAMS = 'Equipos Principales (Paneles e Inversores)'
export const TYPE_CUBAGE_MAIN_TEAMS_OTHERS = 'Equipos Principales (Otros)'
export const TYPE_ADITIONAL = 'Adicionales'

export const TYPES_EXECUTION_MATERIALS = {
  transport: 'Transporte de Personal',
  load_transport: 'Transporte de Carga',
  machinery: 'Maquinaria y Faena',
  labor: 'Mano de obra',
  lodging: 'Hospedaje y Viáticos',
  others: 'Otros'
}

export const DEFAULT_DISPATCH = "1";
export const DISPATCH_SUB_CONTRACT = "SubContrato"

export const CUBAGE_BUNDLE_STATUS = {
  PENDING_APPROVAL: "pending_approval",
  REJECTED: "rejected",
  POSTED_TO_SAP: "posted_to_sap",
  // Replaced by a newer send of the same cubicación before it was approved
  SUPERSEDED: "superseded",
  // Annulled in SAP (ST and SCs closed) by a reset of the cubicación
  CANCELLED: "cancelled"
}

export const CUBAGE_BUNDLE_STATUS_LIST = [
  { id: CUBAGE_BUNDLE_STATUS.PENDING_APPROVAL, name: "Pendiente de aprobación", color: "yellow darken-4", alertType: "info" },
  { id: CUBAGE_BUNDLE_STATUS.REJECTED, name: "Rechazada", color: "red darken-2", alertType: "error" },
  { id: CUBAGE_BUNDLE_STATUS.POSTED_TO_SAP, name: "Enviada a SAP", color: "blue darken-2", alertType: "success" },
  { id: CUBAGE_BUNDLE_STATUS.SUPERSEDED, name: "Reemplazada por un nuevo envío", color: "grey darken-1", alertType: "info" },
  { id: CUBAGE_BUNDLE_STATUS.CANCELLED, name: "Anulada por reinicio de la cubicación", color: "grey darken-1", alertType: "info" }
]

export const tableHeadersPersonalTransport = [
  {
    text: "Nombre",
    align: "center",
    sortable: true,
    value: "name",
  },
  {
    text: "Valor diario",
    align: "center",
    sortable: true,
    value: "Unit_Cost",
  },
  {
    text: "Dias total",
    align: "center",
    sortable: true,
    value: "Days",
  },
  {
    text: "Cantidad",
    align: "center",
    sortable: true,
    value: "Quantity",
  },
  {
    text: "Valor total",
    align: "center",
    sortable: true,
    value: "total_cost",
  },
];

export const tableHeadersFreightTransport = [
  {
    text: "Nombre",
    align: "center",
    sortable: true,
    value: "name",
  },
  {
    text: "Valor",
    align: "center",
    sortable: true,
    value: "Unit_Cost",
  },
  {
    text: "Cantidad",
    align: "center",
    sortable: true,
    value: "Quantity",
  },
  {
    text: "Valor total",
    align: "center",
    sortable: true,
    value: "total_cost",
  },
];

export const tableHeadersMachineryAndWork = [
  {
    text: "Nombre",
    align: "center",
    sortable: true,
    value: "name",
  },
  {
    text: "Valor",
    align: "center",
    sortable: true,
    value: "Unit_Cost",
  },
  {
    text: "Cantidad",
    align: "center",
    sortable: true,
    value: "Quantity",
  },
  {
    text: "Hora",
    align: "center",
    sortable: true,
    value: "Hour",
  },
  {
    text: "Día / Mes",
    align: "center",
    sortable: true,
    value: "Day_Month",
  },
  {
    text: "Valor total",
    align: "center",
    sortable: true,
    value: "total_cost",
  },
];

export const tableHeadersLabor = [
  {
    text: "Nombre",
    align: "center",
    sortable: true,
    value: "name",
  },
  {
    text: "Valor",
    align: "center",
    sortable: true,
    value: "Unit_Cost",
  },
  {
    text: "Personal",
    align: "center",
    sortable: true,
    value: "Staff",
  },
  {
    text: "Día",
    align: "center",
    sortable: true,
    value: "Days",
  },
  {
    text: "Valor total",
    align: "center",
    sortable: true,
    value: "total_cost",
  },
]

export const tableHeadersLodgingAndPerDiem = [
  {
    text: "Nombre",
    align: "center",
    sortable: true,
    value: "name",
  },
  {
    text: "Valor",
    align: "center",
    sortable: true,
    value: "Unit_Cost",
  },
  {
    text: "Personal",
    align: "center",
    sortable: true,
    value: "Staff",
  },
  {
    text: "Día",
    align: "center",
    sortable: true,
    value: "Days",
  },
  {
    text: "Valor total",
    align: "center",
    sortable: true,
    value: "total_cost",
  },
];

export const tableHeadersOthers = [
  {
    text: "Nombre",
    align: "center",
    sortable: true,
    value: "name",
  },
  {
    text: "Valor",
    align: "center",
    sortable: true,
    value: "Unit_Cost",
  },
  {
    text: "Cantidad",
    align: "center",
    sortable: true,
    value: "Quantity",
  },
  {
    text: "Valor total",
    align: "center",
    sortable: true,
    value: "total_cost",
  },
]